// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"fb719ea9","232":"efc26e26","345":"5ed496f2","355":"55838e57","394":"c7550897","469":"674a02e1","475":"7d0612ea","692":"2a92e87b","721":"7f827aee"}[chunkId] + ".chunk.js";
};